// HeaderNavContent.js

import Link from "next/link";
import ServicesDropdown from "./Services";
import {
  blogItems,
  candidateItems,
  employerItems,
  findJobItems,
  homeItems,
  pageItems,
  shopItems,
  servicesPageItem
} from "../../data/mainMenuData";
import {
  isActiveParent,
  isActiveLink,
  isActiveParentChaild,
} from "../../utils/linkActiveChecker";
import { useRouter } from "next/router";

// HeaderNavContent.js

// ... (existing imports)

// ... (existing imports)

// ... (existing imports)

const HeaderNavContent = () => {
  const router = useRouter();

  return (
    <>
      <nav className="nav main-menu">
        <ul className="navigation" id="navbar" style={{zIndex:100000}}>
        <li className={isActiveParent(homeItems, router.asPath) ? "current" : ""}>
    <Link href="/" style={{ fontSize: "1rem" }}>Home</Link>
</li>
<li className={isActiveLink("/about", router.asPath) ? "current" : ""}>
    <Link href="/about" style={{ fontSize: "1rem" }}>About Us</Link>
</li>
<li className="dropdown " >
    <a href="#" style={{ color: "white",fontSize: "1rem"  }}>Services</a>
    <ul className="dropdown-menu">
        {servicesPageItem.map((item, index) => (
            <li key={index}>
                <Link href={item.routePath} style={{ fontSize: "1rem" }}>{item.name}</Link>
            </li>
        ))}
    </ul>
</li>
<li className={isActiveLink("/jobseekers", router.asPath) ? "current" : ""}>
    <Link href="/jobseekers" style={{ fontSize: "1rem" }}>For Jobseekers</Link>
</li>
<li className={isActiveLink("/employer", router.asPath) ? "current" : ""}>
    <Link href="/employer" style={{ fontSize: "1rem" }}>For Employers</Link>
</li>
<li className={isActiveLink("/blog-list", router.asPath) ? "current" : ""}>
    <Link href="/blog-list" style={{ fontSize: "1rem" }}>Blog</Link>
</li>
<li className={isActiveLink("/contact", router.asPath) ? "current" : ""}>
    <Link href="/contact" style={{ fontSize: "1rem" }}>Contact</Link>
</li>

        </ul>
      </nav>
      <style jsx>{`
        .menu {
          list-style: none;
          display: flex;
        }

        .menu li {
          margin-right: 20px;
        }

        .dropdown {
          position: relative;
        }

        .dropdown-menu {
          display: none;
          position: absolute;
          top: 100%;
          left: 0;
          list-style: none;
          background-color: #fff;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
          padding: 10px;
        }

        .dropdown:hover .dropdown-menu {
          display: block;
        }
      `}</style>
      <style jsx>{`
        /* Style for the Links */
        .navigation li a {
          text-decoration: none;
          color: inherit; /* Inherit color from parent */
          transition: border-bottom 0.3s ease; /* Add transition effect */
        }

        /* Style for the Links when hovered */
        .navigation li a:hover {
          border-bottom: 2px solid #fff; /* Add underline effect on hover */
        }

        /* Add additional styling for the current class if needed */
        .navigation li.current a {
          /* Add styles for the current class */
          border-bottom: 2px solid #fff; /* Example: Applying a style for the current class */
        }
      `}</style>
    </>
  );
};

export default HeaderNavContent;

